import { Component } from '@angular/core';
import { LoginPageComponent as FsfLoginPageComponent } from '@freesixtyfive/fe-login-process';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FsfLoginPageComponent],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
})
export class LoginPageComponent {}
